"use strict";

import React from "react";
import ReactDOM from "react-dom";
import PropTypes from 'prop-types';
import Utils from '../Utils.jsx';
import Popup from '../Popup.jsx';

class SliderBlock extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showPopup: false
        };
        this.showValue = this.showValue.bind(this);

    }

    togglePopup() {
        this.setState({
            showPopup: !this.state.showPopup
        });
    }

    componentDidMount() {
        const { autoFocus, disabled } = this.props;
        if (autoFocus && !disabled) {
            this.focus();
        }
    }

    showValue(event) {
        const target = event.target;
        var value = Number(target.value);

        this.props.onChange({ id: this.props.id, value: value });
    }


    render() {

        var sliderCSS = this.props.sliderCSS;
        var min = this.props.min;
        var max = this.props.max;
        var step = this.props.step;
        var title = this.props.title;
        var showRange = this.props.showRange ? this.props.showRange : false;
        var infoText = this.props.infoText;

        var rangeBlock = null;

        if (showRange) {
            rangeBlock =
                <div className="row">
                    <div className="col-xs-6">
                        {Utils.formatDisplayRange(this.props.min, this.props.type)}
                    </div>
                    <div className="col-xs-6" style={{ textAlign: 'right' }} >
                        {Utils.formatDisplayRange(this.props.max, this.props.type)}
                    </div>
                </div>;

        } 

        var infoIcon = null;
        var infoBlock = null;

        if (infoText) {
            infoIcon =
                <i className="fa fa-question-circle fa-lg open-popup" onClick={this.togglePopup.bind(this)}  >
                </i>;

            infoBlock =
                <div className="infoBlock">
                    {infoText}
                </div>;
        }

        

        return <div className={'slider ' + this.props.sliderCSS} >
            <h3>{title + ' '}{infoIcon}</h3>
            <div className="sliderInputBlock">

                <div className="sliderInput">
                    <input type="range" min={min} max={max} step={step}
                        value={this.props.value} onChange={this.showValue} />
                    { rangeBlock   }
                </div>


                <div className="sliderValue">
                    <div className="inputValue">{Utils.formatDisplayValue(this.props.value, this.props.type)}</div>                    
                </div>
            </div>
            {this.state.showPopup ?
                <Popup
                    text={infoBlock}
                    closePopup={this.togglePopup.bind(this)}
                />
                : null
            }
        </div>;
    }
}


SliderBlock.propTypes = {
    defaultValue: PropTypes.number,
    value: PropTypes.number,
    sliderCSS: PropTypes.string,
    min: PropTypes.number,
    max: PropTypes.number,
    step: PropTypes.number,
    id: PropTypes.string,
    title: PropTypes.string,
    showRange: PropTypes.bool,
    infoText: PropTypes.object

}

export default SliderBlock;